export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-vidicon-2-line text-3xl md:text-4xl text-primary-600"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/70 text-secondary-700 text-xs font-medium mb-3">
              关于我们
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-4">平台介绍</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              玫瑰视频是一个专注影视资源聚合的在线观影平台，致力于为广大追剧爱好者提供一站式高清观影体验。
              我们深度整合<strong>香蕉视频</strong>、<strong>糖豆视频</strong>、<strong>小蓝视频</strong>和<strong>蓝莓视频</strong>等
              多个主流平台的优质内容，涵盖电视剧全集、电影大全及最新影视资源。凭借流畅的播放技术和每日更新的内容机制，
              让每一位用户都能享受到不缓冲、不卡顿的高清观影之旅。无论是最新热播剧还是经典老片，玫瑰视频都为你一网打尽。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}